export const PLACEHOLDER_IMAGE_PATH = '/resources/images/Placeholder.png';
export const PRODUCT_PLACEHOLDER_IMAGE_PATH = '/resources/images/productPlaceholder.jpg';
